export default "__VITE_ASSET__Bb9N8xZ2__"